import React from 'react'
import { Row, Col, Input, Button } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
import PermissionWrapper from '../../auth/PermissionWrapper';

class ClientDocuments extends React.Component {

    onDownload = (href, filename) => {
        this.props.log('ClientDocuments.js/onDownload (href,filename)', href, filename);
        fetch(href + filename + "?" + new Date().getTime(), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(
                    new Blob([blob]),
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', decodeURIComponent(filename));
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            })
        .catch(() => {
            this.props.addToast('An error has occurred.', 5, 'danger');
        })
    }

    render = () => {
        this.props.info('ClientDocuments.js/render');
        console.log("process", process.env)
        return (
            <Row>
                <Col md="12">
                    <table className="dataGrid">
                        <thead>
                            <tr>
                                <th>Document</th>
                                <th>Author</th>
                                <th>Uploaded</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.files.filter(file => file.reportId === this.props.selectedClientReportId).map(file => (
                                <tr key={file.uuid}>
                                    <td><Button color="link" onClick={() => this.onDownload("/uploads/" + file.uuid + '/', file.filename)}>{decodeURIComponent(file.filename)}</Button></td>
                                    <td>{file.firstName} {file.lastName}</td>
                                    <td>{this.props.formatAMPM(new Date(String(file.timestamp).substring(0, 19)))}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Col>
                <Col md="12" className="py-3">
                    <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Upload Logo">
                        <Input
                            type="file"
                            key={this.props.randomKey}
                            name={"file_"}
                            id="file"
                            accept='.jpg,.png,.gif,.doc,.docx,.pdf,.xls,.xlsx,.txt,.csv'
                            onChange={e => this.props.handleUpload(e, this.props.selectedClientReportId,'document')}
                        />
                        {/* {this.props.uploadSuccess ?
                            (this.props.saveSuccess ?
                                <Alert color="success">Document upload successful.</Alert> :
                                <Alert color="danger">Document upload unsuccessful.</Alert>) :
                            <></>
                        } */}
                    </PermissionWrapper>
                </Col>
            </Row>
        )
    }
}

export default ClientDocuments;